import { render, staticRenderFns } from "./AreaSetting.vue?vue&type=template&id=dd7e11da"
import script from "./AreaSetting.vue?vue&type=script&lang=js"
export * from "./AreaSetting.vue?vue&type=script&lang=js"
import style0 from "./AreaSetting.vue?vue&type=style&index=0&id=dd7e11da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports